import * as React from 'react';

/** True when the app is in a real narrow viewport or the view switcher is set to mobile. */
export const MobileViewContext = React.createContext(false);
